import Const from '@/helpers/const'
import { custAxios } from './genericApi'

export default {
  getMaintainers (params) {
    return custAxios().get(`${Const.API_MAINTAINER}s?search=${params.search}&page=${params.page}&rowsPerPage=${params.rowsPerPage}&sortDirection=${params.sortDirection}`)
  },
  getOneMaintainer (id) {
    return custAxios().get(`${Const.API_MAINTAINER}/${id}`)
  },
  registerMaintainer (params) {
    return custAxios().post(`${Const.API_MAINTAINER}`, params)
  },
  updateMaintainer (id, params) {
    return custAxios().put(`${Const.API_MAINTAINER}/${id}`, params)
  },
  deleteMaintainer (id) {
    return custAxios().delete(`${Const.API_MAINTAINER}/${id}`)
  },
  getMaintainerPeriods (id) {
    return custAxios().get(`${Const.API_MAINTAINER}/${id}/periods`)
  },
  addMaintainerPeriod (params) {
    return custAxios().post(`${Const.API_MAINTAINER}/${params.maintainerId}/period`, params.period)
  },
  editMaintainerPeriod (params) {
    return custAxios().put(`${Const.API_MAINTAINER}/${params.maintainerId}/period/${params.period.id}`, params.period)
  },
  deleteMaintainerPeriod (params) {
    return custAxios().delete(`${Const.API_MAINTAINER}/${params.accountId}/period/${params.periodId}`)
  },
  linkClientToMaintainer (params) {
    return custAxios().put(`${Const.API_MAINTAINER}/${params.accountId}/client/${params.clientId}`)
  },
  unlinkClientFromMaintainer (params) {
    return custAxios().delete(`${Const.API_MAINTAINER}/${params.accountId}/client/${params.clientId}`)
  }
}
